var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4286 0H2.57143C1.15127 0 0 1.15127 0 2.57143V12.8571C0 14.2773 1.15127 15.4286 2.57143 15.4286H21.4286C22.8487 15.4286 24 14.2773 24 12.8571V2.57143C24 1.15127 22.8487 0 21.4286 0Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M21.4286 0H2.57143C1.15114 0 0 1.15114 0 2.57143V12.8571C0 14.2774 1.15114 15.4286 2.57143 15.4286H21.4286C22.8489 15.4286 24 14.2774 24 12.8571V2.57143C24 1.15114 22.8489 0 21.4286 0ZM23.1429 12.8571C23.1429 13.8026 22.374 14.5714 21.4286 14.5714H2.57143C1.626 14.5714 0.857143 13.8026 0.857143 12.8571V2.57143C0.857143 1.626 1.626 0.857143 2.57143 0.857143H21.4286C22.374 0.857143 23.1429 1.626 23.1429 2.57143V12.8571Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.4289 0.857178H2.57171C1.62456 0.857178 0.857422 1.62432 0.857422 2.57146V3.42861C0.857422 2.48146 1.62456 1.71432 2.57171 1.71432H21.4289C22.376 1.71432 23.1431 2.48146 23.1431 3.42861V2.57146C23.1431 1.62432 22.376 0.857178 21.4289 0.857178Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42843 3.42859H3.857C3.14692 3.42859 2.57129 4.00422 2.57129 4.7143V6.42859C2.57129 7.13867 3.14692 7.7143 3.857 7.7143H6.42843C7.13851 7.7143 7.71415 7.13867 7.71415 6.42859V4.7143C7.71415 4.00422 7.13851 3.42859 6.42843 3.42859Z",
    fill: "#EDAB40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M5.99986 11.1429H3.21415C2.8592 11.1429 2.57129 10.855 2.57129 10.5C2.57129 10.1451 2.8592 9.85718 3.21415 9.85718H5.99986C6.3548 9.85718 6.64272 10.1451 6.64272 10.5C6.64272 10.855 6.3548 11.1429 5.99986 11.1429Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M10.9286 11.1429H8.14286C7.78791 11.1429 7.5 10.855 7.5 10.5C7.5 10.1451 7.78791 9.85718 8.14286 9.85718H10.9286C11.2835 9.85718 11.5714 10.1451 11.5714 10.5C11.5714 10.855 11.2835 11.1429 10.9286 11.1429Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M15.8573 11.1429H13.0716C12.7166 11.1429 12.4287 10.855 12.4287 10.5C12.4287 10.1451 12.7166 9.85718 13.0716 9.85718H15.8573C16.2122 9.85718 16.5001 10.1451 16.5001 10.5C16.5001 10.855 16.2122 11.1429 15.8573 11.1429Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.786 11.1429H18.0003C17.6453 11.1429 17.3574 10.855 17.3574 10.5C17.3574 10.1451 17.6453 9.85718 18.0003 9.85718H20.786C21.1409 9.85718 21.4289 10.1451 21.4289 10.5C21.4289 10.855 21.1409 11.1429 20.786 11.1429Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardOther);
export default __webpack_public_path__ + "static/media/card-other.4bdddbcf486705b712b321bb16d3892b.svg";
export { ForwardRef as ReactComponent };